// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8e4ea6ab","301":"04223d9f","555":"8485a28a","869":"d14ae42b"}[chunkId] + ".chunk.js";
};